import { ComponentType, ReactElement } from 'react';

export type IPublicTypeCustomView = ReactElement | ComponentType<any>;
